export default __webpack_public_path__ + "static/media/flag-aruba.a59d11ad.svg";